import React from 'react';

// Styles
import * as S from './styles';

// Types
type DotsPropTypes = {
    index: number;
    count: number;
    onGoToItem: (index: number) => void;
};

const Dots = ({ index, count, onGoToItem }: DotsPropTypes) => {
    const dots = [];
    for (let i = 0; i < count; i++) {
        dots.push(<S.Dot key={i} isActive={i === index} onClick={() => onGoToItem(i)} />);
    }

    return <S.Container>{dots}</S.Container>;
};

export default Dots;
